<div id="scrollTop" class="absolute top-0"></div>
<div class=" flex flex-col justify-center items-center w-full relative">
  <div class="e-adaptive-demo e-bigger w-full">
    <div class="e-mobile-layout w-full">
      <div class="e-mobile-content w-full">
        <ejs-grid #Ctablel id="Ctablel" [(dataSource)]="parsedData" enableAdaptiveUI="true" [allowExcelExport]="true"
          [rowRenderingMode]="rowMode" [allowFiltering]="false" (commandClick)="emitActionComplete($event)"
          [editSettings]="tableOptions?.inline || ''" [allowSorting]="true" [allowMultiSorting]="false"
          [allowPaging]="paging" [pageSettings]="pageSettings" [loadingIndicator]="{indicatorType: 'Shimmer'}"
          [height]="heightT" [width]="widthT" (rowDataBound)="rowDB($event)" (rowSelected)="rowSelected($event)"
          (dataStateChange)="dataStateChange($event)" [showColumnChooser]='true'
          [selectionSettings]="gridSelectionSetting" (checkBoxChange)="gridCheckboxChange($event)">
          <!--(checkBoxChange)="gridCheckboxChange($event)"-->
          <ng-template #toolbarTemplate>
            <div class="p-2 flex flex-col border-t-grid e-tb">
              <div class="flex flex-wrap justify-between">
                <div class="flex flex-wrap justify-start">
                  <ng-template [ngTemplateOutlet]="template!">

                  </ng-template>


                  <ejs-tooltip id="newTool" target="#filterButton" position="top" [content]="filterTooltip"
                    *ngIf="filterButtonClass">
                    <button id="filterButton"
                      [class]="(showFilter ? 'delete-button' : 'dl-button') + ' transform duration-300 p-2 rounded-xl ml-3 '"
                      (click)="showFilters($event)">
                      <div class="w-6 h-6">

                        <span class="w-full {{filterButtonClass}}"></span>
                      </div>

                    </button>
                  </ejs-tooltip>

                  <!--   <ejs-tooltip *ngIf="rowMode == 'Vertical' && showFilter" id="newTool" target="#filterButton"
                    position="top" [content]="filterTooltip">
                    <button id="filterButton"
                      [class]="'e-icons transform duration-300 e-search e-search-button p-3 rounded-xl'"
                      (click)="dialogComp.open()"></button>
                  </ejs-tooltip> -->


                  <!-- <div *ngIf="showFilter && this.rowMode=='Orizzontal'">
                    <ejs-tooltip id="newTool"  content="Elimina i filtri">
                      <button  class="e-flat e-icons e-close e-clear-button " (click)="showFilters('clear')"></button>
                    </ejs-tooltip>
                  </div> -->
                </div>

                <div>
                  <button *ngIf="tableOptions?.csvGenerator" class="dl-button mx-2 p-3 rounded-xl"
                    (click)="csvExport()">CSV</button>

                  <!-- <ejs-tooltip id="newTool" target="#chooserButton" position="top"
                    [content]="'Seleziona le colonne che vuoi vedere'">
                    <button  #chooserButton id="chooserButton" class="transform duration-300 p-3 rounded-xl"
                      (click)="showChooser()">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M9 4.5v15m6-15v15m-10.875 0h15.75c.621 0 1.125-.504 1.125-1.125V5.625c0-.621-.504-1.125-1.125-1.125H4.125C3.504 4.5 3 5.004 3 5.625v12.75c0 .621.504 1.125 1.125 1.125z" />
                      </svg>

                    </button>

                  </ejs-tooltip> -->
                </div>

              </div>
              <div @onOff [class]="'flex flex-wrap py-2 '" *ngIf="showFilter  && filterTable.length > 0">

                <div *ngFor="let col of filterTable; let i = index">

                  <div *ngIf="(col.type=='text'|| col.type == 'barcode') && !col.filterDropdown" class="px-2.5 py-1.5">
                    <input [id]="col.field" [ngClass]="'e-input e-primary-filtering transform duration-300 '"
                      type="search" (keyup)="pushFilter($event)" [(ngModel)]="col.filterValue" [placeholder]="col.name">
                  </div>
                  <div *ngIf="(col.type=='text'|| col.type == 'barcode' || col.type == 'chip') &&  col.filterDropdown"
                    class="px-2.5 py-1.5 min-w-72">
                    <app-custom-drop-down-list [fieldName]="col.field" [url]="col.dropdownFilterUrl"
                      [placeholder]="col.name" (genericChange)="pushFilter($event)" [value]="col.filterValue"
                      [(ngModel)]="col.filterValue" [api]="true"></app-custom-drop-down-list>
                  </div>
                  <div *ngIf="col.type=='date'" class="px-2.5 py-1.5 flex">
                    <!-- <app-custom-date-picker  [id]="col.field"  [fieldId]="col.field" [value]="col.filterValue || ''" (changeValue)="pushFilter($event)" (keyUp)="pushFilter($event)"></app-custom-date-picker> -->
                    <input #datePicker [id]="col.field" type="date"
                      class="e-input rounded-lg {{col.filterValue != '' ? 'rounded-r-none' : '' }}  transform duration-300"
                      [(ngModel)]="col.filterValue" (keyup)="pushFilter($event)" (change)="pushFilter($event)">
                    <button class="bg-input  rounded-r-lg p-2" *ngIf="col.filterValue != ''"
                      (click)="col.filterValue = '';pushFilter($event)">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                        stroke="currentColor" class="w-6 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                  <div *ngIf="col.type=='checkbox'" class="px-2.5 py-1.5">
                    <div class="e-primary-filtering">
                      <p>{{col.name}}</p>
                      <input [id]="col.field" type="checkbox" [ngClass]="'rounded-2xl p-2 '"
                        [(ngModel)]="col.filterValue" id="{{col.field}}" (change)="pushFilter($event)">

                    </div>
                  </div>
                  <!-- <div *ngIf="col.type=='dropdown'" class="px-2.5" >
                    <input #inputEl [id]="col.field" [ngClass]="'e-input e-primary-filtering transform duration-300 '"
                    type="text" (keyup)="checkFilters($event)" [placeholder]="col.name" >
                  </div> -->
                </div>
              </div>
            </div>
          </ng-template>
          <e-columns>

            <e-column *ngIf="tableOptions?.checkboxed == true" [width]="'50'" type="checkbox">

            </e-column>

            <ng-container *ngFor="let col of gridColConfig; let i = index;">

              <e-column *ngIf="col.type == 'img'" [visible]="col.visible"
                [showInColumnChooser]="!col.hideInColumnChooser" field="{{col.field}}" [allowEditing]="false"
                [headerText]="col.name" [allowSorting]="col.sort || false" [allowFiltering]="col.filter || false"
                [width]="col.width || '100'">
                <ng-template #template let-data>
                  <div class="img-tab-custom">
                    <img id="{{col.field + i.toString()}}" src="{{data[col.field]}}" alt="{{col.name}}"
                      class="{{col.cssClass}}" [ngClass]="{'rounded-lg': col.cssClass == undefined}">
                  </div>
                </ng-template>
              </e-column>

              <e-column *ngIf="col.type == 'button'" [visible]="col.visible"
                [showInColumnChooser]="!col.hideInColumnChooser" field="{{col.field}}" [allowEditing]="false"
                [headerText]="col.name" [allowSorting]="false" [allowFiltering]="false" [width]="col.width || '100'">
                <ng-template #template let-data>

                  <button class="{{col.cssClass}} p-2 rounded-xl e-icons e-icons-grid {{getButtuonIcon(col)}}"
                    (click)="emitBtnClick(data, col.name.toLowerCase(), col.field.toLowerCase())">

                    <!--*ngIf="getButtonLabel(col) != undefined"-->
                  </button>

                </ng-template>
              </e-column>


              <e-column *ngIf="col.type == 'link'" [visible]="col.visible"
                [showInColumnChooser]="!col.hideInColumnChooser" field="{{col.field}}" [allowEditing]="false"
                [headerText]="col.name" [allowSorting]="false" [allowFiltering]="false" [width]="col.width || '100'">
                <ng-template #template let-data>

                  <button *ngIf="data[col.field]"
                    class="{{col.cssClass}} p-2 rounded-xl text-primary-500 flex justify-start items-center gap-1"
                    (click)="emitBtnClick(data, col.name.toLowerCase(), col.field.toLowerCase())" [title]="data[col.field]">
                    {{data[col.field]}}
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="w-4 h-4">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6" />
                      <path d="M11 13l9 -9" />
                      <path d="M15 4h5v5" />
                    </svg>
                    <!--*ngIf="getButtonLabel(col) != undefined"-->
                  </button>
                  <p *ngIf="!data[col.field]">-</p>

                </ng-template>
              </e-column>




              <e-column *ngIf="col.type == 'text'" [visible]="col.visible"
                [showInColumnChooser]="!col.hideInColumnChooser" field="{{col.field}}" [allowEditing]="col.edit"
                [headerText]="col.name" [allowFiltering]="col.filter || true" [allowSorting]="col.sort || true"
                [width]="col.width || '100'" [textAlign]="col.textAlign">
                <ng-template #template let-data>

                  <div class="dtest text-base truncate " title="{{data[col.field]}}">
                    {{col.textFieldOptions?.prefix}}{{data[col.field] || (col.textFieldOptions?.emptyPlaceHolder ||
                    "-")}}{{col.textFieldOptions?.append}}
                  </div>

                </ng-template>
              </e-column>

              <e-column *ngIf="col.type == 'switch'" [visible]="col.visible"
                [showInColumnChooser]="!col.hideInColumnChooser" field="{{col.field}}" [headerText]="col.name"
                [allowFiltering]="col.filter || false" [allowSorting]="col.sort || true" [width]="col.width || '100'">
                <ng-template #template let-data>
                  <ejs-switch class="grid-switch-comp" id="{{col.field + i}}" [checked]="data[col.field]"
                    (change)="switchChange($event, data)"></ejs-switch>
                </ng-template>
              </e-column>

              <!-- <e-column *ngIf="col.type == 'dropdown'" field="{{col.field}}" [headerText]="col.name" [allowFiltering]="col.filter || false" [allowSorting]="col.sort || true"
                [width]="col.width || '100'">
                <ng-template #template let-data>
                  <ejs-dropdownlist [dataSource]="col.dropdown" [fields]="col.ddO" [value]="data[col.field]"  #dropdownList class="e-input transform duration-300"></ejs-dropdownlist>
                </ng-template>
              </e-column> -->

              <e-column *ngIf="col.type == 'color'" [visible]="col.visible"
                [showInColumnChooser]="!col.hideInColumnChooser" field="{{col.field}}" [headerText]="col.name"
                [allowFiltering]="col.filter || false" [allowSorting]="col.sort || true" [width]="col.width || '100'">
                <ng-template #template let-data>
                  <span class="flex my-2 justify-center items-center w-full">

                    <div *ngIf="data[col.field].hex" class="rounded-2xl w-14 h-10"
                      [style]="'background-color: '+data[col.field].hex">
                    </div>

                    <div *ngIf="data[col.field].svg">
                      <img [src]="'data:image/svg+xml;base64,'+getSVG(data[col.field].svg)"
                        class="h-16 w-16 object-cover rounded-full">
                    </div>

                  </span>

                </ng-template>
              </e-column>

              <e-column *ngIf="col.type == 'state'" [visible]="col.visible"
                [showInColumnChooser]="!col.hideInColumnChooser" field="{{col.field}}" [headerText]="col.name"
                [allowFiltering]="col.filter || false" [allowSorting]="col.sort || true" [width]="col.width || '100'">
                <ng-template #template let-data>
                  <div class="p-4 rounded-full e-icons flex flex-row justify-center items-center" style="color:white;"
                    id="{{col.field + i}}"
                    [ngStyle]="{width: getColorWidth(col) || '40px', height: getColorHeight(col) || '40px'}"
                    [ngClass]="{'bg-red-500 e-close': data[col.field] == false || data[col.field] == null || data[col.field] == undefined,'bg-emerald-500 e-check': data[col.field] == true}">
                  </div>
                </ng-template>
              </e-column>

              <e-column *ngIf="col.type == 'chip'" [visible]="col.visible"
                [showInColumnChooser]="!col.hideInColumnChooser" field="{{col.field}}" [headerText]="col.name"
                [allowFiltering]="col.filter || false" [allowSorting]="col.sort || true" [width]="col.width || '100'">
                <ng-template #template let-data>
                  <div class="p-2 rounded-2xl text-white w-min" id="{{col.field + i}}"
                    [ngStyle]="{'background-color': data[col.field].split('_')[1]}">

                    {{data[col.field].split("_")[0]}}
                  </div>
                </ng-template>
              </e-column>

              <e-column *ngIf="col.type == 'checkbox'" [visible]="col.visible"
                [showInColumnChooser]="!col.hideInColumnChooser" field="{{col.field}}" [headerText]="col.name"
                [allowFiltering]="col.filter || false" [allowSorting]="col.sort || true" [width]="col.width || '100'">
                <ng-template #template let-data>
                  <ejs-checkbox class="grid-chekbox-comp" id="{{col.field + i}}" [checked]="data[col.field]"
                    (change)="checkBoxChange($event, data)"></ejs-checkbox>
                </ng-template>
              </e-column>

              <e-column *ngIf="col.type == 'date'" [visible]="col.visible"
                [showInColumnChooser]="!col.hideInColumnChooser" field="{{col.field}}" [headerText]="col.name"
                [allowFiltering]="col.filter || true" [allowSorting]="col.sort || true" [width]="col.width || '100'">
                <ng-template #template let-data>
                  <div class="table-data-format">{{data[col.field] | date}}</div>
                </ng-template>
              </e-column>

              <e-column *ngIf="col.type == 'dateTime'" [visible]="col.visible"
                [showInColumnChooser]="!col.hideInColumnChooser" field="{{col.field}}" [headerText]="col.name"
                [allowFiltering]="col.filter || true" [allowSorting]="col.sort || true" [width]="col.width || '100'">
                <ng-template #template let-data>
                  <div class="table-data-format">{{data[col.field] | date: 'dd/MM/YYYY-HH:mm'}}</div>
                </ng-template>
              </e-column>

              <e-column *ngIf="col.type == 'barcode'" [visible]="col.visible"
                [showInColumnChooser]="!col.hideInColumnChooser" field="{{col.field}}" [headerText]="col.name"
                [allowFiltering]="col.filter || true" [allowSorting]="col.sort || true" [width]="col.width || '100'">
                <ng-template #template let-data>
                  <div class="flex flex-col items-center w-auto">
                    <!-- <ejs-barcodegenerator style="display: block;" [mode]="data[col.barcodeOptions!.mode]" [width]="data[col.barcodeOptions!.width]" [height]="data[col.barcodeOptions!.heigth]"
                  [type]="data[col.barcodeOptions!.format]" [value]="data[col.field]"
                  >

                  </ejs-barcodegenerator> -->

                    <ngx-barcode [bc-value]="data[col.field]" [bc-format]="'CODE128B'" [bc-width]="barcodeWidth"
                      class="w-auto"></ngx-barcode>
                    <p>{{data[col.field]}}</p>
                  </div>

                </ng-template>
              </e-column>

            </ng-container>
          </e-columns>
        </ejs-grid>




        <!-- Filtering dialog for mobile -->
        <app-custom-dialog id="mobileFiltering" class="absolute m-5 pt-3" (open)="onDialogOpen($event)"
          #mobileFiltering>



          <div class="flex flex-col mx-auto" *ngIf="showFilter">
            <div *ngFor="let col of gridColConfig; let i = index">

              <div *ngIf="col.type=='text' && !col.filterDropdown && col.filter != false" class="px-2.5 py-1.5">
                <input #inputEl [id]="col.field" [ngClass]="'e-input e-primary-filtering transform duration-300 '"
                  type="search" (keyup)="pushFilter($event)" [placeholder]="col.name">
              </div>
              <div *ngIf="col.type=='text' &&  col.filterDropdown" class="px-2.5 py-1.5">
                <app-custom-drop-down-list [fieldName]="col.field" [url]="col.dropdownFilterUrl"
                  [placeholder]="col.name" (genericChange)="pushFilter($event)"
                  [api]="true"></app-custom-drop-down-list>
              </div>
              <div *ngIf="col.type=='date' && col.filter != false" class="px-2.5 py-1.5">
                <app-custom-date-picker [fieldId]="col.field" (keyUp)="pushFilter($event)"></app-custom-date-picker>
              </div>

            </div>
            <button class="e-search-button " (click)="dialogComp.close()">
              Mostra i risultati
            </button>
          </div>



        </app-custom-dialog>
      </div>
    </div>
  </div>




  <div class="absolute top-20 bg-primary-300/30 backdrop-blur-lg p-3  justify-center rounded-2xl" style="z-index: 100;"
    *ngIf="loading">

    <app-loading-animation></app-loading-animation>

  </div>